// Convert 24-hour time (HH:MM or HH:MM:SS) to 12-hour format (h:MM AM/PM)
export const formatTo12Hour = (time24) => {
  if (!time24) return '';
  
  // Handle both HH:MM and HH:MM:SS formats
  const parts = time24.split(':');
  let hours = parseInt(parts[0]);
  const minutes = parts[1];
  
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 should be 12
  
  return `${hours}:${minutes} ${ampm}`;
};

// Convert 12-hour time (h:MM AM/PM) to 24-hour format (HH:MM)
export const formatTo24Hour = (time12) => {
  if (!time12) return '';
  
  const [time, period] = time12.split(' ');
  let [hours, minutes] = time.split(':');
  hours = parseInt(hours);
  
  if (period === 'PM' && hours !== 12) {
    hours += 12;
  } else if (period === 'AM' && hours === 12) {
    hours = 0;
  }
  
  return `${hours.toString().padStart(2, '0')}:${minutes}`;
};

// Format time range
export const formatTimeRange = (startTime, endTime) => {
  return `${formatTo12Hour(startTime)} - ${formatTo12Hour(endTime)}`;
};

// Parse a YYYY-MM-DD date string as local time (not UTC).
// new Date("2026-03-26") creates UTC midnight which shifts the day in negative timezones.
// Appending T12:00:00 forces local-time parsing and using noon avoids DST edge cases.
export const parseLocalDate = (dateStr) => {
  if (!dateStr) return new Date();
  const clean = dateStr.split('T')[0]; // strip any existing time component
  return new Date(`${clean}T12:00:00`);
};
